import React, { Component } from 'react'
import { safeParse } from '../utils';
const Parser = safeParse;
import { 
  ArrowIcon 
} from './SVGIcons';

class App extends Component {

  render() {

    const { data } = this.props
    const literature = data?.literature || {}

    return (
      <div className='mt-[70px] xl:mt-[80px] tracking-[-0.04em] leading-none'>
        <div className='container'>
          <div className='flex justify-center xl:justify-start items-center gap-[10px] text-[14px] xl:text-[16px]'>
            <div className='inline-flex items-center px-[15px] h-[38px] bg-[#F5F7F9] rounded-full gap-[5px]'>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.5 12.5548V3.50228C16.5 2.60228 15.765 1.93478 14.8725 2.00978H14.8275C13.2525 2.14478 10.86 2.94728 9.525 3.78728L9.3975 3.86978C9.18 4.00478 8.82 4.00478 8.6025 3.86978L8.415 3.75728C7.08 2.92478 4.695 2.12978 3.12 2.00228C2.2275 1.92728 1.5 2.60228 1.5 3.49478V12.5548C1.5 13.2748 2.085 13.9498 2.805 14.0398L3.0225 14.0698C4.65 14.2873 7.1625 15.1123 8.6025 15.8998L8.6325 15.9148C8.835 16.0273 9.1575 16.0273 9.3525 15.9148C10.7925 15.1198 13.3125 14.2873 14.9475 14.0698L15.195 14.0398C15.915 13.9498 16.5 13.2748 16.5 12.5548Z" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9 4.11768V15.3677" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5.8125 6.36768H4.125" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M6.375 8.61768H4.125" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <div className='tracking-[-0.04em] text-[#032432]/60'>Техническая литература</div>
            </div>
          </div>
          <h2 className='font-medium mt-[20px] xl:mt-[30px] text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start leading-none'>{Parser(literature?.title)}</h2>
          <div className='mt-[10px] text-[14px] xl:text-[16px] text-center xl:text-start text-black/60'>{Parser(literature?.text)}</div>
          <div className='grid grid-cols-1 xl:grid-cols-5 gap-[10px] mt-[20px]'>
            {(literature?.items || []).map( (elm) => (
              <div className='rounded-[15px] bg-[#F5F7F9] p-[20px]'>
                <div className='flex flex-row-reverse xl:flex-col justify-between items-start gap-[16px] w-full'>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.5 18V7C3.5 3 4.5 2 8.5 2H15.5C19.5 2 20.5 3 20.5 7V17C20.5 17.14 20.5 17.28 20.49 17.42" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M6.35 15H20.5V18.5C20.5 20.43 18.93 22 17 22H7C5.07 22 3.5 20.43 3.5 18.5V17.85C3.5 16.28 4.78 15 6.35 15Z" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8 7H16" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8 10.5H13" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div className='text-[#032432] text-[16px] xl:text-[18px]'>{elm?.part} <span class="text-[#032432]/60">{elm?.name}</span></div>
                </div>
                <a href={elm.file} target='_blank' className='flex items-center justify-center gap-[9px] h-[38px] xl:h-[50px] bg-[#009EE3] rounded-full px-[33px] mt-[20px] xl:mt-[7px] text-[14px] xl:text-[16px]'>
                  <div className='text-white'>Читать документ</div>
                  <ArrowIcon />
                </a>
              </div>
            ) )}
          </div>
        </div>
      </div>
    );
  }
}

export default App